const dev = {
  s3: {
    REGION: "eu-west-2",
    BUCKET: "help-my-mind-backend-dev-attachmentsbucket-1s65bk5hsw0nc"
  },
  apiGateway: {
    REGION: "eu-west-2",
    URL: "https://api.helpmymind.co.uk/dev"
  },
  cognito: {
    REGION: "eu-west-2",
    USER_POOL_ID: "eu-west-2_8II7HZ3fQ",
    APP_CLIENT_ID: "6lc5142nie4olsoosb2e2er54s",
    IDENTITY_POOL_ID: "eu-west-2:eecad3de-e391-4058-a713-470c0bbd8ca8"
  }
};

const prod = {
  s3: {
    REGION: "eu-west-2",
    BUCKET: "help-my-mind-backend-prod-attachmentsbucket-1l4d8dfrx6ec6"
  },
  apiGateway: {
    REGION: "eu-west-2",
    URL: "https://api.helpmymind.co.uk/prod"
  },
  cognito: {
    REGION: "eu-west-2",
    USER_POOL_ID: "eu-west-2_S5PQSCErW",
    APP_CLIENT_ID: "36c38l9to8b0ja65rs5tn26fl6",
    IDENTITY_POOL_ID: "eu-west-2:488f0918-deff-451f-a6b5-8d1dafc3a231"
  }
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};



// WEBPACK FOOTER //
// ./src/config.js